import App from 'app/app.js';
import { sanitizeInput, EMOJI_REGEX } from '@app/utils/sanitize';

function LtKeyFilterDirective() {
  return {
    restrict: 'A',
    require: '?ngModel',
    link: function (scope, element, attrs, ctrl) {
      let value;
      const filterName = attrs.ltKeyFilter === 'name';
      const filterEmail = attrs.ltKeyFilter === 'email';
      const maxlength = attrs.maxlength;

      if (filterEmail) {
        element.on('beforeinput', (e) => {
          const originalEvent = e.originalEvent || e;
          const data = originalEvent.data;

          if (data && EMOJI_REGEX.test(data)) {
            e.preventDefault();
          }

          EMOJI_REGEX.lastIndex = 0;
        });
      }

      if (filterName) {
        element.on('input', () => {
          value = sanitizeInput(element.val(), '');
          if (!!maxlength && value.length >= maxlength) {
            value = R.substringTo(maxlength, value);
          }
          element.val(value);
          if (ctrl) {
            scope.$apply(() => {
              ctrl.$setViewValue(value);
            });
          }
        });
      }
      if (!!maxlength) {
        element.on('keypress', function (e) {
          value = element.val();
          // Do not allow typing once max length is reached but accept
          // characters backspace, tab, left arrow, right arrow, delete
          if (value.length >= maxlength && !R.contains(e.keyCode, [8, 9, 37, 39, 46])) {
            e.preventDefault();
          }
        });
      }
      if (ctrl && maxlength) {
        ctrl.$formatters.push(function (val) {
          if (!val) {
            return val;
          }

          if (filterName || filterEmail) {
            val = sanitizeInput(val);
          }

          if (val.length > maxlength) {
            val = val.substring(0, maxlength);
          }

          return val;
        });
      }
    }
  };
}

App.directive('ltKeyFilter', [LtKeyFilterDirective]);
